export const customerTableConfig = {
  propList: [
    {prop: 'nickName', label: '客户昵称', minWidth: '80'},
    {prop: 'externalUserid', label: '客户ID', minWidth: '80'},
    {prop: 'status', label: '状态', minWidth: '80', slotName: 'status'},
    {prop: 'takeoverTime', label: '接替时间', minWidth: '80'},
    {prop: 'errmsg', label: '转接信息', minWidth: '80'}
  ]
}
